var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocgoutExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4034_44202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3281 2.5C15.9658 2.49996 16.5794 2.7436 17.0433 3.18107C17.5073 3.61854 17.7865 4.21676 17.824 4.85333L17.8281 5V15C17.8282 15.6377 17.5845 16.2513 17.1471 16.7152C16.7096 17.1792 16.1114 17.4584 15.4748 17.4958L15.3281 17.5H5.32812C4.69045 17.5 4.07686 17.2564 3.61291 16.8189C3.14895 16.3815 2.8697 15.7832 2.83229 15.1467L2.82813 15V5C2.82809 4.36232 3.07173 3.74874 3.50919 3.28478C3.94666 2.82083 4.54488 2.54158 5.18146 2.50417L5.32812 2.5H15.3281ZM15.3281 4.16667H7.82812V15.8333H15.3281C15.5322 15.8333 15.7292 15.7584 15.8818 15.6227C16.0343 15.4871 16.1317 15.3002 16.1556 15.0975L16.1615 15V5C16.1614 4.79589 16.0865 4.59889 15.9509 4.44636C15.8152 4.29383 15.6283 4.19638 15.4256 4.1725L15.3281 4.16667Z",
    fill: "#8FA1A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3287 8.28092C10.3414 8.0784 10.4276 7.88748 10.5711 7.74399C10.7274 7.58776 10.9393 7.5 11.1603 7.5C11.3812 7.5 11.5932 7.58776 11.7494 7.74399L13.4161 9.41066L13.4853 9.48899C13.6096 9.64933 13.6712 9.84953 13.6585 10.0521C13.6458 10.2546 13.5596 10.4455 13.4161 10.589L11.7494 12.2557L11.6711 12.3248C11.5108 12.4492 11.3106 12.5108 11.108 12.4981C10.9055 12.4853 10.7146 12.3991 10.5711 12.2557L10.5019 12.1773C10.3776 12.017 10.316 11.8168 10.3287 11.6143C10.3414 11.4117 10.4276 11.2208 10.5711 11.0773L11.6478 9.99982L10.5711 8.92232L10.5019 8.84399C10.3776 8.68365 10.316 8.48344 10.3287 8.28092Z",
    fill: "#8FA1A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4034_44202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.328125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocgoutExpand);
export default __webpack_public_path__ + "static/media/locgout_expand.df953603ae7bac7291fef7e724747b19.svg";
export { ForwardRef as ReactComponent };